/**
 * Priority cities from the business roadmap.
 * IDs match production `cities.id` on rtl.
 */

import type { TFunction } from 'i18next';

export type RoadmapCity = {
    id: number;
    title: string;
    country: string;
    countryLabel: string;
};

export const ROADMAP_CITIES: RoadmapCity[] = [
    { id: 1, title: 'Milan', country: 'it', countryLabel: 'Italy' },
    { id: 2, title: 'Bergamo', country: 'it', countryLabel: 'Italy' },
    { id: 3, title: 'Verona', country: 'it', countryLabel: 'Italy' },
    { id: 4, title: 'Sirmione', country: 'it', countryLabel: 'Italy' },
    { id: 5, title: 'Desenzano', country: 'it', countryLabel: 'Italy' },
    { id: 6, title: 'Como', country: 'it', countryLabel: 'Italy' },
    { id: 7, title: 'Lugano', country: 'ch', countryLabel: 'Switzerland' },
    { id: 8, title: 'Riga', country: 'lv', countryLabel: 'Latvia' },
    { id: 9, title: 'Tallinn', country: 'ee', countryLabel: 'Estonia' },
    { id: 10, title: 'Vilnius', country: 'lt', countryLabel: 'Lithuania' },
    { id: 11, title: 'Prague', country: 'cz', countryLabel: 'Czechia' },
    { id: 12, title: 'Kraków', country: 'pl', countryLabel: 'Poland' },
    { id: 13, title: 'Budapest', country: 'hu', countryLabel: 'Hungary' },
    { id: 14, title: 'Vienna', country: 'at', countryLabel: 'Austria' },
    { id: 15, title: 'Bratislava', country: 'sk', countryLabel: 'Slovakia' },
    { id: 16, title: 'Brno', country: 'cz', countryLabel: 'Czechia' },
    { id: 17, title: 'Dubrovnik', country: 'hr', countryLabel: 'Croatia' },
    { id: 18, title: 'Split', country: 'hr', countryLabel: 'Croatia' },
    { id: 19, title: 'Porto', country: 'pt', countryLabel: 'Portugal' },
    { id: 20, title: 'Seville', country: 'es', countryLabel: 'Spain' },
    { id: 21, title: 'Granada', country: 'es', countryLabel: 'Spain' },
    { id: 22, title: 'Málaga', country: 'es', countryLabel: 'Spain' },
    { id: 23, title: 'Thessaloniki', country: 'gr', countryLabel: 'Greece' },
    { id: 24, title: 'Pskov', country: 'ru', countryLabel: 'Russia' },
    { id: 25, title: 'Berlin', country: 'de', countryLabel: 'Germany' },
    { id: 26, title: 'Salzburg', country: 'at', countryLabel: 'Austria' },
    { id: 27, title: 'Florence', country: 'it', countryLabel: 'Italy' },
    { id: 28, title: 'Saint Petersburg', country: 'ru', countryLabel: 'Russia' },
    { id: 29, title: 'Paris', country: 'fr', countryLabel: 'France' },
    { id: 30, title: 'London', country: 'gb', countryLabel: 'United Kingdom' },
    { id: 31, title: 'Rome', country: 'it', countryLabel: 'Italy' },
    { id: 32, title: 'Barcelona', country: 'es', countryLabel: 'Spain' },
    { id: 33, title: 'Amsterdam', country: 'nl', countryLabel: 'Netherlands' },
    { id: 34, title: 'Madrid', country: 'es', countryLabel: 'Spain' },
    { id: 35, title: 'Lisbon', country: 'pt', countryLabel: 'Portugal' },
    { id: 36, title: 'Venice', country: 'it', countryLabel: 'Italy' },
    { id: 37, title: 'Athens', country: 'gr', countryLabel: 'Greece' },
    { id: 38, title: 'Munich', country: 'de', countryLabel: 'Germany' },
    { id: 39, title: 'Dublin', country: 'ie', countryLabel: 'Ireland' },
    { id: 40, title: 'Edinburgh', country: 'gb', countryLabel: 'United Kingdom' },
    { id: 41, title: 'Copenhagen', country: 'dk', countryLabel: 'Denmark' },
    { id: 42, title: 'Stockholm', country: 'se', countryLabel: 'Sweden' },
    { id: 43, title: 'Brussels', country: 'be', countryLabel: 'Belgium' },
    { id: 44, title: 'Bruges', country: 'be', countryLabel: 'Belgium' },
    { id: 45, title: 'Nice', country: 'fr', countryLabel: 'France' },
    { id: 46, title: 'Naples', country: 'it', countryLabel: 'Italy' },
    { id: 47, title: 'Valencia', country: 'es', countryLabel: 'Spain' },
    { id: 48, title: 'Warsaw', country: 'pl', countryLabel: 'Poland' },
    { id: 49, title: 'Zurich', country: 'ch', countryLabel: 'Switzerland' },
    { id: 50, title: 'Reykjavik', country: 'is', countryLabel: 'Iceland' },
    { id: 51, title: 'Lyon', country: 'fr', countryLabel: 'France' },
    { id: 52, title: 'Istanbul', country: 'tr', countryLabel: 'Turkey' },
    { id: 62, title: 'Kaş', country: 'tr', countryLabel: 'Turkey' },
    { id: 63, title: 'Bangkok', country: 'th', countryLabel: 'Thailand' },
    { id: 64, title: 'Guangzhou', country: 'cn', countryLabel: 'China' },
    { id: 65, title: 'Kuala Lumpur', country: 'my', countryLabel: 'Malaysia' },
    { id: 66, title: 'Ho Chi Minh City', country: 'vn', countryLabel: 'Vietnam' },
    { id: 67, title: 'Hanoi', country: 'vn', countryLabel: 'Vietnam' },
    { id: 68, title: 'Da Nang', country: 'vn', countryLabel: 'Vietnam' },
    { id: 69, title: 'Hong Kong', country: 'hk', countryLabel: 'Hong Kong' },
    { id: 70, title: 'Macau', country: 'mo', countryLabel: 'Macau' },
];

const ALL = 'all';

/** Mantine 9 Select expects groups as `{ group, items }` — not flat `{ group, value, label }`. */
export const roadmapCitySelectData = (t: TFunction) => [
    { value: ALL, label: t('components.cityQuickSelect.allCities') },
    ...Object.entries(
        ROADMAP_CITIES.reduce<Record<string, { value: string; label: string }[]>>((acc, city) => {
            const group = city.countryLabel;
            if (!acc[group]) acc[group] = [];
            acc[group].push({
                value: String(city.id),
                label: `${city.title} · #${city.id}`,
            });

            return acc;
        }, {}),
    ).map(([group, items]) => ({ group, items })),
];

export function parseCityFilter(value: string): number | null {
    if (!value || value === ALL) return null;

    const cityId = Number(value);

    return Number.isFinite(cityId) && cityId > 0 ? cityId : null;
}
